module.exports = __webpack_public_path__ + "3d1c655f3ec01f901a92e7b7f1de811a.svg";